var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"figureSelector",attrs:{"title":"Select a figure","hide-footer":"","no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":""}},[_c('div',{staticClass:"figures"},_vm._l((_vm.figures),function(figure){return _c('div',{key:figure,staticClass:"figure",class:( _obj = {}, _obj[_vm.color + figure] = true, _obj ),on:{"click":function($event){_vm.selectFigure(figure)}}})
var _obj;}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e1c8570","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FigureSelector.vue
// module id = null
// module chunks = 